import { CountryBrandApplication } from "../domain/CountryBrandApplication";

const getDataByID = (id: string) => {
	const requestOptions = {
		method: "GET",
		headers: {
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
		},
	};

	if (id === "new") return { ok: false };

	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications/${id}`,
		requestOptions
	);
};

const getAllData = (token: string) => {
	const requestOptions = {
		method: "GET",
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		},
	};
	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications`,
		requestOptions
	);
};

const updateData = (data: CountryBrandApplication) => {
	// const myHeaders = new Headers();
	// myHeaders.append("Content-Type", "application/json");

	const requestOptions = {
		method: "PUT",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(data),
	};

	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications?id=${data.id}`,
		requestOptions
	);
};

const postFile = (file: { applicationId: string; group: string; file: File }) => {
	const data = new FormData();
	data.append("id", file.applicationId);
	data.append("group", file.group);
	data.append("File", file.file);

	const requestOptions: RequestInit = {
		method: "POST",
		body: data,
		redirect: "follow",
	};

	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications/CountryBrandApplications/UploadFile`,
		requestOptions
	);
};

const postNew = (data: string) => {
	const myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");

	const requestOptions: RequestInit = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: data,
	};

	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications`,
		requestOptions
	);
};

const signInWithEmailAndPassword = (data: string) => {
	const myHeaders = new Headers();
	myHeaders.append("Content-Type", "application/json");

	const requestOptions: RequestInit = {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: data,
	};

	return fetch(`${process.env.REACT_APP_API_SERVER_URL}/api/Login/login`, requestOptions);
};

const deleteFile = (data: { applicationId: string; id: string }) => {
	const requestOptions = {
		method: "DELETE",
	};

	return fetch(
		`${process.env.REACT_APP_API_SERVER_URL}/api/CountryBrandApplications/CountryBrandApplications/DeleteFile?id=${data.id}&applicationId=${data.applicationId}`,
		requestOptions
	);
};

export {
	getAllData,
	getDataByID,
	updateData,
	postFile,
	postNew,
	signInWithEmailAndPassword,
	deleteFile,
};
